export default __webpack_public_path__ + "static/SRF 3325ACS50 - Product Specifications & Technical Data-e87757437a3514f9db7068905c9e533b.pdf";